import { useSelector } from 'react-redux';
import { isExperimentActive, getParameter } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../ExperimentKeys';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getHasExposureBeenTracked, setHasExposureBeenTracked } from '../useExperiment';
const checkExperimentACQ149Active = state => {
  return isExperimentActive(state, ExperimentKeys.ACQ0149);
};
const checkExperimentACQ149Parameter = state => {
  return getParameter(state, ExperimentKeys.ACQ0149);
};
const trackExposure = (shouldTrackExposure, parameter) => {
  const hasExposureBeenTracked = getHasExposureBeenTracked(ExperimentKeys.ACQ0149);
  if (shouldTrackExposure && !hasExposureBeenTracked) {
    getTracker().track(EventName.ExperimentExposure, {
      action: `${ExperimentKeys.ACQ0149}-group-${parameter}`
    }, true);
    setHasExposureBeenTracked(ExperimentKeys.ACQ0149);
  }
};
export const useShouldTrackACQ149 = () => {
  const shouldTrackExposure = useSelector(checkExperimentACQ149Active);
  const parameter = useSelector(checkExperimentACQ149Parameter);
  const trackACQ149Exposure = () => {
    trackExposure(shouldTrackExposure, parameter);
  };
  return {
    trackACQ149Exposure
  };
};
export const trackACQ149ExposureForGooglePrompt = state => {
  const shouldTrackExposure = checkExperimentACQ149Active(state);
  const parameter = checkExperimentACQ149Parameter(state);
  trackExposure(shouldTrackExposure, parameter);
};